import { SalOrderHdrDto, SalOrderDtlDto } from "src/dtos/salorder/salOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

// 판매주문 전체 데이터 구조 (API 호출과 일치)
export interface SAL1011_R01Dto {
  salesOrderHeaderDto: SAL1011_R01HeaderDto;
  salesOrderDetailDtoList: SAL1011_R01DetailDto[];
}

// 판매주문 헤더 DTO (기존 SalOrderHdrDto 확장)
export interface SAL1011_R01HeaderDto extends SalOrderHdrDto {
}

// 판매주문 상세 DTO (단일 상속 방식)
export interface SAL1011_R01DetailDto extends SalOrderDtlDto {
	completeTransport: number;
}




export const defaultSAL1011_R01HeaderDto: SAL1011_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	
	salesOrderNo: '',
	compCd: '',
	compNm: '',
	customCd: '',
	customNm: '',
	empNm: '',
	orderDt: formatDate(new Date()),
	moneyCd: '',
	vatType: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totBaseVat: 'N',
	totalAmt: 0,
	dueDt: formatDate(new Date()),
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	detailAddress: '',
	empNo: '',
	approveFlg: 'N',
	orderStatus: '',
	remark: '',

	insertDt: new Date().toISOString(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date().toISOString(),
	updateUser: '',
	updateForm: '',

	inserted: false,
	isModified: false
};

export const defaultSAL1011_R01DetailDto: SAL1011_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salesOrderNo: '',
	itemNo: '',
	compCd: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 1,
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderUnit: '',
	orderQty: 1,
	cancelQty: 0,
	completeTransport: 0,
	orderPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	remark: '',

	insertDt: new Date().toISOString(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date().toISOString(),
	updateUser: '',
	updateForm: '',

	inserted: false,
	isModified: false
};
